/// <reference path="events.ts" />
export const Type = Function;
;
// #region CONSTS
export const WATCH_PROPS_VAR = 'pacem:properties';
export const INSTANCE_BINDINGS_VAR = 'pacem:custom-element:bindings';
export const INSTANCE_HOST_VAR = 'pacem:custom-element:host';
export const INSTANCE_SCOPE_VAR = 'pacem:custom-element:scope';
// #endregion
//}
